<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Material Transaction</h6>
             </div>
             
             <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Material Transaction</a>
         </div>

     <div class="card">
    <div class="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-4">
        
        <!-- Start Date -->
        <div class="w-full lg:w-auto">
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input type="date" id="startDate" v-model="startDate" class="w-full p-2 border border-gray-300 rounded" />
        </div>

        <!-- End Date -->
        <div class="w-full lg:w-auto">
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input type="date" id="endDate" v-model="endDate" class="w-full p-2 ml-3 mb-4 border border-gray-300 rounded" />
        </div>

        <!-- Filter Button -->
        <div>
            <button type="submit" @click="filterPurchases" class="btn btn-primary-solid px-5 mt-5 ml-5 mb-4 lg:mt-0 cursor-pointer">Filter</button>
        </div>
    </div>

    <div class="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-4 ">
        
        <!-- Vendor Filter: Branch -->
        <div class="w-full lg:w-auto" style="width: 250px;">
            <label for="employee_name" class="block text-sm font-medium text-gray-700">Search Employee</label>
            <select class="form-input w-full p-2 border border-gray-300 rounded" id="employee_name" ref="employee_name" v-model="sale.employee_name">
                <option value=""></option>
                <option value="All">ALL</option>
                <option v-for="(item, index) in employeeList" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div>

        <!-- Vendor Filter: Material Name -->
        <div class="w-full lg:w-auto mb-4" style="width: 250px; margin-bottom: 16px;">
            <label for="material_name" class="block text-sm font-medium text-gray-700">Material Name</label>
            <select class="form-input w-full p-2 border border-gray-300 rounded" id="material_name" ref="material_name" v-model="sale.material_name">
                <option value=""></option>
                <option value="All">ALL</option>
                <option v-for="(item, index) in materialList" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
    </div>
</div>

            <div class="card">
                <!-- Static heading -->
                <div id="printable-content">
                    <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                    <h1 class="print-only" style="text-align: center;">Material Transcation</h1>
                </div>

                <button
                    type="reset"
                    @click="printReceipt"
                    class="btn b-light btn-danger-light btn-sm"
                >
                    Print
                </button>
                </div>
                <div class="printonly">
                    From {{startDate}} To {{endDate}}
                </div>


        
<!-- Start All Language List Table -->
<div class="p-3 sm:p-4">
    <div class="overflow-x-auto scrollbar-table">
        <table id="languageTable" class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
            <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                <tr>
                    <th class="px-3.5 py-4">Check Out Date</th>
                    <th class="px-3.5 py-4">Employee Name</th>
                    <th class="px-3.5 py-4">Branch Name</th>
                    <th class="px-3.5 py-4">Plot Name</th>
                    <th class="px-3.5 py-4">Material Name</th>
                    <th class="px-3.5 py-4">CheckOut Qty</th>
                    <th class="px-3.5 py-4">CheckIn Qty</th>
                    <th class="px-3.5 py-4">Check In Date</th>
                    <th class="px-3.5 py-4">Note</th>
                    <th class="px-3.5 py-4">Action</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item, index) in catList" :key="item.id">
                    <td class="px-3.5 py-4">{{ item.checkout }}</td>
                    <td class="px-3.5 py-4">{{ item.employee_name }}</td>
                    <td class="px-3.5 py-4">{{ item.branch_name }}</td>
                    <td class="px-3.5 py-4">{{ item.plot_name }}</td>
                    <td class="px-3.5 py-4">{{ item.material_name }}</td>      
                    <td class="px-3.5 py-4">{{ item.checkoutqty }}</td>
                    <td class="px-3.5 py-4">{{ item.checkinqty }}</td>
                    <td class="px-3.5 py-4">
                        <span 
                          @click="filterPendingRecords" 
                          class="cursor-pointer text-blue-500 hover:underline"
                        >
                          {{ item.checkin === '0000-00-00' || !item.checkin ? 'Pending' : item.checkin }}
                        </span>
                      </td>
                    <td class="px-3.5 py-4">{{ item.note }}</td>
                    <td class="px-3.5 py-4">
                        <div class="flex items-center gap-1">

                            <button class="btn-icon btn-primary-icon-light size-7" @click="updateModal(item)">
                                <i class="ri-save-line text-inherit text-[13px]"></i>
                            </button>

                            <button class="btn-icon btn-primary-icon-light size-7" @click="editModal(item)">
                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                            </button>

                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)">
                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<!-- End All Language List Table -->

     </div>
 </div>
 <!-- End Main Content -->





<!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full h-screen bg-black bg-opacity-50">
    <div class="p-4 w-full max-w-lg overflow-hidden">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square h-full flex flex-col">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            
            <div class="p-4 md:p-5 overflow-y-auto">
                <!-- <label>Date : <input type="date" v-model="cat.entry_date"></label> -->

                <div class="p-4 md:p-5">

                    <div class="mt-7">
                        <label for="" class="form-label">Entry Date *</label>
                        <input type="date" id="barcode" v-model="cat.entry_date" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                        </div>

                   
                    <div class="mt-7">
                        <label for="" class="form-label">Checkout Date *</label>
                        <input type="date" id="barcode" v-model="cat.checkout" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                        </div>
                

                    <div class="mt-7">
                        <div class="w-full lg:w-auto">
                            <label for="branches_name" class="block text-sm font-medium text-gray-700">Search Branch</label>
                            <select class="form-input w-full p-2 border border-gray-300 rounded" @change="fillPlots()" id="branches_name" ref="branches_name" v-model="cat.branchid">
                                <option value=""></option>
                                <!-- <option value="All">ALL</option> -->
                                <option v-for="(item, index) in branchList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>




                    <div class="mt-7">
                        <div class="w-full lg:w-auto">
                            <label for="plot_name" class="block text-sm font-medium text-gray-700">Search Plot</label>
                            <select class="form-input w-full p-2 border border-gray-300 rounded" id="plot_name" ref="plot_name" v-model="cat.plotid">
                                <option value=""></option>
                                <!-- <option value="All">ALL</option> -->
                                <option v-for="(item, index) in plotList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>



                    <div class="mt-7">
                        <div class="w-full lg:w-auto">
                            <label for="employee_name" class="block text-sm font-medium text-gray-700">Search Employee</label>
                            <select class="form-input w-full p-2 border border-gray-300 rounded" id="employee_name" ref="employee_name" v-model="cat.employeeid">
                                <option value=""></option>
                                <!-- <option value="All">ALL</option> -->
                                <option v-for="(item, index) in employeeList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                        </div>
                        </div>



    
                    <div class="mt-7">
                        <div class="w-full lg:w-auto">
                            <label for="materials_name" class="block text-sm font-medium text-gray-700">Search Material</label>
                            <select class="form-input w-full p-2 border border-gray-300 rounded" id="materials_name" ref="materials_name" v-model="cat.materialid">
                                <option value=""></option>
                                <!-- <option value="All">ALL</option> -->
                                <option v-for="(item, index) in materialList" :key="index" :value="item.id">
                                    {{ item.name }} ({{ item.available_qty }})
                                  </option>                                  
                            </select>
                        </div>
                    </div> 

                    <div class="mt-7">
                        <label for="" class="form-label">Checkout Qty *</label>
                        <input type="number" id="barcode" v-model="cat.checkoutqty" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                  



             </div>




            </div>
            <div class="flex justify-end p-4">
                <button @click="save_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
            </div>
        </div>
    </div>
</div>


<!-- start update Modal -------------------------------------------------------------------------------------------------------------------->
<!-- Start Edit Modal -->
<div id="updateModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full h-screen bg-black bg-opacity-50">
    <div class="p-4 w-full max-w-lg overflow-hidden">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square h-full flex flex-col">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            
            <div class="p-4 md:p-5 overflow-y-auto">
                <!-- <label>Date : <input type="date" v-model="cat.entry_date"></label> -->

                <div class="p-4 md:p-5">
                   
                    <div class="mt-7">
                        <lable>Fill up While Receving Material.</lable>    
                        </div>

                        
                        <div class="mt-7">
                            <label for="" class="form-label">Check In *</label>
                            <input type="date" id="barcode" v-model="cat.checkin" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
    
    
                        <div class="mt-7">
                            <label for="" class="form-label">Checkin Qty *</label>
                            <input type="number" id="barcode" v-model="cat.checkinqty" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>

                        <div class="mt-7">
                            <label for="" class="form-label">Note *</label>
                            <input type="text" id="barcode" v-model="cat.note" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>

                  



             </div>




            </div>
            <div class="flex justify-end p-4">
                <button @click="update_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
            </div>
        </div>
    </div>
</div>






<!-- end update Modal --------------------------------------------------------------------------------------------------------------------->






 <!-- Start Delete Modal -->
 <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-md max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             <div class="p-4 md:p-5 text-center">
                 <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                 <div class="mt-5 text-center">
                     <h5 class="mb-1">Are you sure?</h5>
                     <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                     <div class="flex justify-center gap-2 mt-6">
                         <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                         <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
 <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'ProductCategory',
components: {
 
} ,
mounted(){
// this.getBasics();
},

data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId:0,
     startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
     endDate: today,
     isTableVisible: false, // Initially table is hidden
     ledgerList:[],
     lastrecord:[],
     employeeList:[],
     branchList:[],
     plotList:[],
     all_employeeList:[],
     materialList:[],
     all_plotList:[],
     addgroupList:[],
    //  items: [], // Ensure this is initialized as an array
     filteredItems: [],
     sale: {
        branch_name: null,
        material_name: null,
        employee_name:null,
        branches_name:null,
        plot_name:null,
        materials_name:null,
     },  // New property to store filtered group
     catList:[],
     allSuggestions: [], // Example suggestions
      filteredSuggestions: [],
     cat:{entry_date:this.todayDate(),employeeid:'',materialid:'',branchid:'',plotid:'',note:'',checkout:this.todayDate(),checkin:this.todayDate(),qty:'',entry_date:this.todayDate(),},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 
 }, 

methods:{
    closeModal(){
        
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            $("#updateModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
    },

    filterPendingRecords() {
    this.catList = this.catList.filter(item => 
        !item.checkin || item.checkin.trim() === '' || item.checkin === '0000-00-00'
    );
},





fillPlots() {

          var selected_branchid=event.target.value;
         
            this.plotList = this.all_plotList.filter(item => {
               
                return item.branchid === selected_branchid; // Ensure entryDate is a property of item 
               
            });

        //     var selected_branchid=event.target.value;
         
        //    this.employeeList = this.all_employeeList.filter(item => {
            
        //      return item.employeeid === selected_branchid; // Ensure entryDate is a property of item 
            
        //  });





    },



  

 todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },

    


    filterPurchases(){
       var self=this;
         axios.post('getmattranscation',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
               self.employeeList = response.data.employeelist;
               self.all_employeeList = response.data.employeelist;
               self.materialList = response.data.materiallist;
               self.branchList = response.data.branchlist;
               self.plotList = response.data.plotlist;
               self.all_plotList = response.data.plotlist;
               self.catList=response.data.allmateriallist;
               self.original_catList=response.data.allmateriallist;
          
               
                }).then(()=>{
                        // self.cat.ledgerid=self.lastrecord.ledgerid;
                        // self.cat.groupid=self.lastrecord.groupid;



                        $("#employee_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                    //    alert(event.target.value);
                                    //         self.sale.branchid=event.target.value;  
                                            self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.employeeid === event.target.value);
                                               
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                            $('.datatable').DataTable().destroy();                
                                            
                                        });




//-------------------------------------------------------------------------------------------------------------------------


                        $("#material_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Material Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                       // alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                            self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.materialid === event.target.value);
                                               
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                            $('.datatable').DataTable().destroy();                
                                            
                                        });
                     










                     
                        $('#languageTable').DataTable();
                });
  },



 addModal(){
this.cat={employeeid:'',materialid:'',branchid:'',plotid:'',checkout:this.todayDate(),checkin:'',qty:'',entry_date:this.todayDate()};
    
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;

     if(!this.isAdd)
         $("#updateModal").removeClass('hidden');
     else
         $("#updateModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;




 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 updateModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#updateModal").removeClass('hidden');
     else
         $("#updateModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },



 
 deleteModal(id){
     this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getmattranscation',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
               self.employeeList = response.data.employeelist;
               self.materialList = response.data.materiallist;
               self.branchList = response.data.branchlist;
               self.plotList = response.data.plotlist;
               //self.catList=response.data.allmateriallist;
              // self.original_catList=response.data.allmateriallist;
          
               
                }).then(()=>{
                        // self.cat.ledgerid=self.lastrecord.ledgerid;
                        // self.cat.groupid=self.lastrecord.groupid;



                        $("#employee_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                    //    alert(event.target.value);
                                    //         self.sale.branchid=event.target.value;  
                                            self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.employeeid === event.target.value);
                                               
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                            $('.datatable').DataTable().destroy();                
                                            
                                        });




//-------------------------------------------------------------------------------------------------------------------------


                        $("#material_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Material Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                       // alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                            self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.materialid === event.target.value);
                                               
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                            $('.datatable').DataTable().destroy();                
                                            
                                        });
                     










                     
                        $('#languageTable').DataTable();
                });
  },
  save_category() {
             var self = this; 
             axios.post('addmaterialtranscation', this.cat)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                     self.employees=response.data.userDetails;
                     self.cat={name:'',status:'Active'};
                     self.filterPurchases();  
                     self.closeModal();
                     //self.$swal(msg);
                     if (isSuccess == 1) {
                         self.closeModal();
                     }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },

         update_category() {
             var self = this; 
             axios.post('updatematerialtranscation', this.cat)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    self.employees=response.data.userDetails;
                     self.cat={name:'',status:'Active'};
                     self.getBasics();  
                     self.closeModal();
                     //self.$swal(msg);
                     if (isSuccess == 1) {
                         self.closeModal();
                     }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },



         printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },






         delete_category() {
             var self = this; 
             axios.post('deletemtranscation', {deleteId:this.deleteId})
                 .then(response => {
                   
                   //  self.catList=response.data.cats;
                     self.employees=response.data.userDetails; 
                    self.closeModal(); 
                    self.filterPurchases();
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
}
}



</script>




<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
        display: block; 
    }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>